import axios from 'axios';
import React, { FormEvent, useState } from 'react';
import { Modal } from 'react-bootstrap';
import {
  defaultBloodPressureReading,
  IBloodPressureReadingDTO,
} from '../../../interface/BloodPressureInterface';
import { isFormValidated } from '../../../utils/formUtils';
import { addToast } from '../../../utils/toastNotifications';
import { endpoints } from '../../../utils/URL';
import ButtonLoader from '../../common/ButtonLoader';
import { IPatientModal } from '../../../interface/CommonInterface';

const BloodPressureModal = ({ show, close, patientId, callback }: IPatientModal) => {
  const [isLoading, setIsLoading] = useState(false);
  const [bloodPressure, setBloodPressure] = useState<IBloodPressureReadingDTO>(
    defaultBloodPressureReading
  );

  const handleChange = (input: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setBloodPressure({
      ...bloodPressure,
      [input]: event.target.value,
    });
  };

  const saveReading = async (event: FormEvent) => {
    if (!isFormValidated('add-bp-modal')) {
      addToast('Please fill all fields', 'warning');
      return;
    }
    event.preventDefault();
    bloodPressure.patientId = patientId;

    setIsLoading(true);
    const url = `${endpoints.bloodPressures.mainUrl}`;

    try {
      await axios.post(url, bloodPressure);
      addToast('BP reading added successfully', 'success');
      if (callback) {
        callback();
      }
      close();
    } catch (error) {
      addToast('An error occured while saving data');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={close} backdrop={isLoading ? 'static' : true}>
      <form id='add-bp-modal'>
        <Modal.Header closeButton>
          <Modal.Title>Add Blood Pressure Reading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <fieldset disabled={isLoading}>
            <div className='form-group'>
              <label className='required'>Systolic</label>
              <input
                type='number'
                className='form-control'
                value={bloodPressure.systolic}
                onChange={handleChange('systolic')}
                required
                min={1}
                max={300}
              />
            </div>
            <div className='form-group'>
              <label className='required'>Diastolic</label>
              <input
                type='number'
                className='form-control'
                value={bloodPressure.diastolic}
                onChange={handleChange('diastolic')}
                required
                min={1}
                max={300}
              />
            </div>
            <div className='form-group'>
              <label className='required'>Heart Rate</label>
              <input
                type='number'
                className='form-control'
                value={bloodPressure.heartRate}
                onChange={handleChange('heartRate')}
                required
                min={1}
                max={300}
              />
            </div>
            <div className='form-group'>
              <label>Reading date</label>
              <input
                type='date'
                className='form-control'
                value={bloodPressure.readingDate}
                onChange={handleChange('readingDate')}
                required
              />
            </div>
            <div className='form-group'>
              <label>Reading time</label>
              <input
                type='time'
                className='form-control'
                value={bloodPressure.readingTime}
                onChange={handleChange('readingTime')}
                required
              />
            </div>
          </fieldset>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-primary' type='submit' onClick={saveReading}>
            Save
            {isLoading ? <ButtonLoader /> : ''}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default BloodPressureModal;
